<template>
  <div class="cr-result">
    <div class="cr-container">
      <div class="cr-result__body">
        <div class="cr-result__title cr-result__title--second">
          Ваша заявка принята. Менеджер свяжется с Вами
        </div>
      </div>
      <div class="cr-result__bottom">
        <router-link class="cr-button cr-button--light" to="/">
                        <span class="cr-button__text">
                            На главную
                        </span>
        </router-link>
        <router-link class="cr-button cr-button--light" to="/">
                        <span class="cr-button__text">
                            Каталог
                        </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {

}
</script>
